import React from 'react';

const Compass = (props: React.SVGProps<any>) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={90}
            fill="none"
            {...props}
        >
            <g clipPath="url(#a)">
                <path
                    fill="#B7B7B7"
                    d="M16 52.05v37.97c.788 0 1.56-.523 1.905-1.589l13.697-42.496c.099-.302.148-.603.148-.925H21.748c0 3.882-2.578 7.04-5.748 7.04Z"
                />
                <path
                    fill="#DB3800"
                    d="M16 37.97V0c-.788 0-1.56.523-1.905 1.589L.398 44.085a2.931 2.931 0 0 0-.148.925h10.002c0-3.881 2.578-7.04 5.748-7.04Z"
                />
                <path
                    fill="#D6D6D6"
                    d="M10.252 45.01H.25c0 .322.05.623.148.925l13.697 42.496c.345 1.066 1.133 1.59 1.905 1.59V52.048c-3.17 0-5.748-3.157-5.748-7.039Z"
                />
                <path
                    fill="#BD4200"
                    d="M17.905 1.589C17.56.523 16.772 0 16 0v37.97c3.17 0 5.748 3.159 5.748 7.04H31.75c0-.322-.05-.623-.148-.925L17.905 1.589Z"
                />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M.25 0h31.5v90H.25z"/>
                </clipPath>
            </defs>
        </svg>
    );
}

export default Compass;
